var $loadMoreAcademy,
    $academyGrid,
    $academyPage = 1,
    $academyOffset,
    $academySubjects,
    $academyRows,
    $academyThemeBlock,
    $academySidebar,
    paginationOffset;

$(document).ready(function($) {

    $loadMoreAcademy = $('.js-load-more-academy');
    $academyGrid     = $('.js-theme-grid');
    $academySubjects = $('.js-academy-subject');
    $academyRows = $('.js-themes-rows');
    $academyThemeBlock = $(".js-theme-block");
    $academySidebar = $('.js-academy-sidebar')

    paginationOffset = $loadMoreAcademy.attr('data-offset');
    var theme = $loadMoreAcademy.attr('data-theme');

    $loadMoreAcademy.on('click', function(e){
        e.preventDefault();

        if(!$(this).hasClass('is-loading')) {
            loadNextItems(theme);
        }
    });

    $academySubjects.on('change', function () {
        /*
            $loadMoreAcademy.removeClass('is-hidden');
            $academyGrid.empty();
            $academyPage = 0;
            loadNextItems(theme);
         */
        $academySidebar.addClass('is-loading');

        var $items = $("input[name='subjects']:checked");
        // Reset page number
        $academyPage = 0;

        // Show load more - loading
        $loadMoreAcademy.removeClass('is-hidden');

        // Empty grid
        $academyGrid.empty();

        // Show/hide grid on academy archive
        if ($items.length === 0) {
            $academyRows.removeClass('is-hidden');
            $academyThemeBlock.addClass('is-hidden')
            $academySidebar.removeClass('is-loading');
        } else {
            $academyRows.addClass('is-hidden');
            $academyThemeBlock.removeClass('is-hidden')
        }

        // Check if we are on theme detail page
        if (typeof theme !== 'undefined') {
            loadNextItems(theme);
        } else {
            if ($items.length !== 0) {
                loadNextItems(null);
            }
        }
    });
});

function loadNextItems(theme) {
    $loadMoreAcademy.addClass('is-loading');

    var subjects = [];
    $.each($("input[name='subjects']:checked"), function(){
        subjects.push($(this).val());
    });


    jQuery.ajax({
        url : linku_ajax_url,
        type : 'post',
        data : {
            action : 'academy_load_more',
            page : $academyPage + 1,
            offset: $academyOffset,
            theme: theme,
            subjects: subjects,
        },
        dataType: 'json',
        success : function( response ) {
            $academyPage++;


            if(! response.meta.has_next) {
                $loadMoreAcademy.first().addClass('is-hidden');
            }

            $academyGrid.first().append(response.html);
            $loadMoreAcademy.first().removeClass('is-loading');

            $academySidebar.removeClass('is-loading');
        }
    });
}
